import { Stack } from "@mui/material"
import { TEmailReportPerformance } from "./types"
import KeyEngagementMetrics from "../../../components/emailAPIanalytics/keyEngagementMetrics"
import { EngagementTrends } from "../../../components/emailAPIanalytics/engagementTrends"
import { EmailAPIFactory, EOperatorTypes, getDate, getStartOfDate, splitArray, TEmailReport } from "cakemail-ui-components-v2"
import { fillMissingReportIntervals, returnEmailTagsQuery } from "../../../utils/data"
import { getAPIDateRange, getIntervalBasedOnTimeRange } from "../../../utils/date"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { emptyReportLog } from "../../../data/emailAPI"

export function EmailReportPerformance({ timeRange, tagFilter }: TEmailReportPerformance) {
    const { t, i18n } = useTranslation()


    const [loading, setLoading] = useState<boolean>(true)
    const [metrics, setMetrics] = useState<TEmailReport[]>()
    const [error, setError] = useState<boolean>(false)

    useEffect(fetchLogs, [timeRange, tagFilter])

    function fetchLogs() {
        setLoading(true)

        const interval = getIntervalBasedOnTimeRange(timeRange)
        const apiTimeRange = getAPIDateRange({ range: timeRange })
        EmailAPIFactory.getReport({
            interval: interval,
            tags: returnEmailTagsQuery(tagFilter, { operator: EOperatorTypes.and }),
            startTime: apiTimeRange.start,
            endTime: apiTimeRange.end,
        }).then((data) => {
            try {
                fillMissingReportIntervals(data, apiTimeRange.start, apiTimeRange.end, interval, emptyReportLog)
            } catch (e) {
                setError(true)
                return
            }

            setMetrics(data)
            setLoading(false)
            setError(false)
        }).catch(() => {
            setError(true)
        })
    }


    const splitMetricsForTrends = metrics ? splitArray<TEmailReport>(metrics, metrics.length - (metrics.length / (1))) : undefined

    const engagementTrendsProps = {
        metrics: splitMetricsForTrends?.secondArray,
        trendMetrics: splitMetricsForTrends?.secondArray,
        //todo re add when trend dorpdown is back and working with graph
        //trendMetrics: splitMetricsForTrends?.firstArray,
        error,
        loading
    }

    return <Stack className="emailReportPerformance" gap={8}>
        <KeyEngagementMetrics
            timeRange={timeRange}
            tagsFilter={tagFilter}
        />

        <EngagementTrends
            controlled
            controlledProps={engagementTrendsProps}
            headingTxt={t("header-positive-trends-heading")}
            headingTooltipTxt={t("header-positive-trends-heading-tooltip")}
            availableNavItem={["clickthru_rate", "open_rate"]}
            timeRange={timeRange}
            tagsFilter={tagFilter}
            trendRange={1}
        />

        <EngagementTrends
            controlled
            controlledProps={engagementTrendsProps}
            headingTxt={t("header-negative-trends-heading")}
            headingTooltipTxt={t("header-negative-trends-heading-tooltip")}
            availableNavItem={["unsubscribe_rate", "bounce_rate", "spam_rate"]}
            timeRange={timeRange}
            tagsFilter={tagFilter}
            trendRange={1}
        />
    </Stack>
}